import {
  HStack,
  Icon,
  Slider,
  SliderFilledTrack,
  SliderThumb,
  SliderTrack,
  Text,
  VStack,
} from '@chakra-ui/react'

import { SecurityDevice } from '@/components/icons'

interface DeviceSliderPropsI {
  min: number
  max: number
  value: number
  onChange: (value: number) => void
}

export const DeviceIconSizeSlider = ({
  min,
  max,
  value,
  onChange,
}: DeviceSliderPropsI) => {
  const hiveWatchLightBlue = '#C9DBF8'
  const hiveWatchDarkBlue = '#353849'
  const foregroundColor = '#000000'
  const backgroundColor = '#FFFFFF'
  const sliderHandleColor = '#FFFFFF'
  const borderColor = '#D9D9D9'

  const label = 'Device Icon size'
  return (
    <VStack
      alignItems='start'
      backgroundColor={backgroundColor}
      border='1px solid'
      borderColor={borderColor}
      borderRadius={10}
      padding={5}
      spacing={2}
      width={225}
    >
      <HStack spacing={2}>
        <Icon as={SecurityDevice} boxSize={5} strokeColor={foregroundColor} />
        <Text color={foregroundColor} fontSize={14} fontWeight={400}>
          {label}
        </Text>
      </HStack>

      <Slider max={max} min={min} onChange={onChange} step={0.05} value={value}>
        <SliderTrack bg={hiveWatchLightBlue}>
          <SliderFilledTrack bg={hiveWatchDarkBlue} />
        </SliderTrack>
        <SliderThumb
          bg={sliderHandleColor}
          borderColor={borderColor}
          borderWidth='1px'
        />
      </Slider>
    </VStack>
  )
}
